/** Wie in `frontend/src/lib/pricingBreakdownDisplay.ts` — API-`billing_unit` lesbar machen. */
const EXTRA_BILLING_DE: Record<string, string> = {
  flat: 'pauschal',
  per_guest: 'pro Person',
  per_night: 'pro Nacht',
  per_guest_night: 'pro Person & Nacht',
}

export function extraServiceBillingLabel(u: string | null | undefined): string {
  if (u == null || u === '') return ''
  return EXTRA_BILLING_DE[u] ?? u
}
